module.exports = __webpack_public_path__ + "img/pr-10.37c628ef.png";